import { ErrorApi } from '../../api/problema';
import { avisoBreveDeError } from '../../logica/estados';

/** Texto de un error de una acción del buzón: solo lectura con el texto de la API; si no, el `detail` del Problem. */
export function textoDeError(e: unknown, porDefecto: string): string {
    // G703: en WhatsApp todo mensaje consume; sin saldo, la respuesta da `409 no_balance`.
    if (e instanceof ErrorApi && e.estado === 409 && (e.problema as Record<string, unknown>).channel_reason === 'no_balance') {
        return 'Te has quedado sin mensajes de WhatsApp; compra un paquete en Plan.';
    }
    return avisoBreveDeError(e) ?? (e instanceof ErrorApi ? (e.problema.detail ?? e.problema.title) : porDefecto);
}
